import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import RedirectRoute from "./RedirectRoute";
import { connect } from "react-redux";
import LoginIndex from "./components/Login";
import OnBoardingIndex from "./components/OnBoarding";
import PersonalDetails from "./components/OnBoarding/PersonalDetails";
import { AuthTest } from "./utils/auth-test";
import { StorageTest } from "./utils/storage-test";
import Portal from "./components/Portal";
import {
  COLLECTIONS,
  getDoc,
  listenAuthStateChange,
  setDoc,
  AuthCallBackParams,
  getSubCollectionData,
  updateDoc,
} from "./firebase";
import { signIn, logout, userAddress, userDocuments, saveAddressRef } from "./Store/Actions";
import MobilenumberInput from "./components/Login/mobilenumber";
import { Loader } from "./utils/loader";
import { IonToast } from "@ionic/react";
import { intializeIntercom, shutdownMessanger } from "./intercom";

const Routes = (props: any) => {
  React.useEffect(() => {
    listenAuthStateChange(registerUser);
    // shutdownMessanger(); //! uncomment this line to shutdown intercom
    return () => {};
  }, []);

  const registerUser = async ({ uid, token, ...rest }: AuthCallBackParams) => {
    if (token) {
      const data: any = await getDoc(uid, COLLECTIONS.USERS);

      const address: any = await getSubCollectionData(
        uid,
        COLLECTIONS.USERS,
        COLLECTIONS.ADDRESSES,
      );
      if (!data.exists) {
        const payload = {
          uid,
          name: rest.displayName || "",
          email: rest.email || "",
          primaryPhoneNumber: rest.phoneNumber || "",
          profileImagePath: rest.photoURL || "",
          onBoarding: rest.isAnonymous ? true : false,
          profileCompleteness: 0,
          defaultAddressRef: rest.defaultAddressRef || "",
          defaultVehicleRef: rest.defaultVehicleRef || "",
          isAnonymous: rest.isAnonymous ? true : false,
        };
        setDoc(uid, payload, COLLECTIONS.USERS);
        props.signIn({
          ...payload,
          token,
          selectedVehicleRef: payload.defaultVehicleRef,
        });
      } else if (data.exists) {
        props.signIn({
          ...data.data,
          date_of_birth: !!data.data.date_of_birth
            ? new Date(data.data.date_of_birth.seconds * 1000).toUTCString()
            : "",
          // defaultAddressRef: data.data.hasOwnProperty("defaultAddressRef")
          //   ? data.data.defaultAddressRef.path
          //   : "",
          defaultAddressRef: data.data.hasOwnProperty("defaultAddressRef")
            ? data.data.defaultAddressRef
            : "",
          // defaultVehicleRef: data.data.hasOwnProperty("defaultVehicleRef")
          //   ? data.data.defaultVehicleRef.path
          //   : "",
          defaultVehicleRef: data.data.hasOwnProperty("defaultVehicleRef")
            ? data.data.defaultVehicleRef
            : "",
          token,
          // selectedVehicleRef: data.data.hasOwnProperty("defaultVehicleRef")
          //   ? data.data.defaultVehicleRef.path
          //   : "",
          selectedVehicleRef: data.data.hasOwnProperty("defaultVehicleRef")
            ? data.data.defaultVehicleRef
            : "",
        });
        props.saveAddressRef(
          data.data.hasOwnProperty("defaultAddressRef") && !!data.data.defaultAddressRef
            ? data.data.defaultAddressRef.split("/").pop()
            : "",
        );
      }
      props.userAddress(address.data);
    } else {
      props.logout();
    }
  };

  return (
    <>
      <Switch>
        <Route path="/" render={(props) => <Redirect to="/portal" {...props} />} exact />
        <RedirectRoute path={["/login", "/sign-in", "/signIn", "/otp"]} component={LoginIndex} />
        <RedirectRoute path={["/otp-verify"]} component={MobilenumberInput} />
        <RedirectRoute path={["/personal-details"]} component={PersonalDetails} />
        <RedirectRoute path={["/auth-test"]} component={AuthTest} />
        <RedirectRoute path={["/storage-test"]} component={StorageTest} />
        <ProtectedRoute
          path={["/portal"]}
          component={Portal}
          // role={props.role}
        />
        <ProtectedRoute
          path={["/onboarding"]}
          component={OnBoardingIndex}
          // role={props.role}
        />
        {/* <Route path="*" component={RouteNotFound} /> */}
      </Switch>
      {props.showLoader ? <Loader loader={props.showLoader} /> : null}
      {props.toaster ? (
        <IonToast
          isOpen={props.toaster ? true : false}
          color={props.severity || "danger"}
          position="top"
          cssClass="toast_style"
          message={props.errorMessage || `Error occured`}
          duration={3000}
        />
      ) : null}
      <div id="recaptcha-container" />
    </>
  );
};

export default connect(
  ({ auth: { role_id, role }, loader: { showLoader }, toast }: any) => {
    return {
      showLoader,
      role_id,
      role,
      ...toast,
    };
  },
  {
    signIn,
    logout,
    userAddress,
    userDocuments,
    saveAddressRef,
  },
)(Routes);
